import { getVocabulary } from "components/Vocabulary";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const titleMap: Record<string, string | (() => string)> = {
  dashboard: "Dashboard",
  insights: "Insights",
  findings: "Findings",
  scans: "Scans",
  discovery: "Discovery",
  assets: "Assets",
  feeds: "Feeds",
  integrations: "Integrations",
  runbook: "Runbooks",
  reports: "Compliance",
  assetsummary: "Repo Summary",
  ticketListing: "Tickets",
  "security-tools": "Security Tools",
  scheduledReport: "Scheduled Reports",
  compliance: "Compliance Policies",
  log: "Audit Logs",
  "user-management": "User Management",
  globalsettings: "Global Settings",
  sbom: "Supply Chain",
  groups: () => getVocabulary("group", true),
  product_old: () => getVocabulary("product", true),
  subProduct_old: () => getVocabulary("subProduct", true),
  project: () => getVocabulary("project", true),
  exceptions: () => getVocabulary("exception", true),
  assessments: () => getVocabulary("assessment", true),
};

export const getTitle = (title: string): string => {
  const value = titleMap[title];
  if (title === "logout" || title === "login" || !value) return "ArmorCode";
  const resolvedTitle = typeof value === "function" ? value() : value;
  return `${resolvedTitle} - ArmorCode`;
};

const TitleManager: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    const segments = path.split("/").filter(Boolean);
    const title = segments[3];
    document.title = getTitle(title);
  }, [location.pathname]);

  return null;
};

export default TitleManager;
